import { render, staticRenderFns } from "./ProjMemberManage.vue?vue&type=template&id=0828400e&scoped=true"
import script from "./ProjMemberManage.vue?vue&type=script&lang=js"
export * from "./ProjMemberManage.vue?vue&type=script&lang=js"
import style0 from "./ProjMemberManage.vue?vue&type=style&index=0&id=0828400e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0828400e",
  null
  
)

export default component.exports